export default __webpack_public_path__ + "static/media/native-section.88dde58c.png";